import React, {useEffect, useState} from "react";
import {useIntl} from 'react-intl';

// Components
import {Form} from 'Components';
import {Grid} from '@mui/material';
import Pill from "Components/Pill";
import TriggerLandmark from "Modules/alerts/components/wizardAlert/common/components/TriggerLandmark";


export const OffHour = (props) => {

    const { value, onChange, formRef, triggers, triggersRaw } = props
    const { messages } = useIntl()
    const [showErrorTrigger, setShowErrorTrigger] = useState(false)

    useEffect(() => {
        if (value.offHourEvents == undefined)
            onChange({
                ...value,
                offHourEvents: []
            })
    }, [value])

    const pillName = {
        Ignition: messages['alertsNewAlert_Ignition'],
        Drive: messages['alertsNewAlert_Drive'],
        Input: messages['alertsNewAlert_Input'],
        Geofence: messages['alertsNewAlert_Geofence'],
        Landmark: messages['alertsNewAlert_Landmark'],
    }

    /**
     * Transform the received events from ['Ignition']
     * to [{ name: 'Ignition', id: 'Ignition }] to handle
     * the pills view.
     */
    const transformedInSelectedOptions = value.offHourEvents?.map((selectedOption) => {
        return { id: selectedOption, name: pillName[selectedOption] };
    }) || [];

    /**
     * Transform the received events from [{ name: 'Ignition', id: 'Ignition }]
     * to ['Ignition'] to handle
     * the API method for save or update the alert.
     */
    const transformedOutSelectedOptions = (options) => options.map((option) => option.id);

    const options = [
        { name: pillName['Ignition'], id: 'Ignition' },
        { name: pillName['Drive'], id: 'Drive' },
        { name: pillName['Input'], id: 'Input' },
        { name: pillName['Geofence'], id: 'Geofence' },
        { name: pillName['Landmark'], id: 'Landmark' },
    ];

    return (
        <Form ref={formRef}
            onSubmit={() => {
                if (value.trigger) {
                    let isValid = triggersRaw?.length > 0

                    if (!isValid) {
                        setShowErrorTrigger(true)
                    } else setShowErrorTrigger(false)
                    return isValid && value.offHourEvents?.length > 0
                } else {
                    return value.offHourEvents?.length > 0;
                }
            }}
        >
            <Grid container justifyContent={'center'} direction={'column'} style={{ paddingTop: 10 }}>
                <div style={{ paddingBottom: 10 }}>
                    <label className="input-normal-label">
                        {messages['alertsNewAlert_SelectEvents']}
                        <span className="text-danger"> *</span>
                    </label>

                    {
                        value.offHourEvents?.length == 0 &&
                        <div className="text-danger" style={{ paddingTop: 10 }}>
                            {messages["alertsNewAlert_triggerValidation"]}
                        </div>
                    }
                </div>
                <Grid container direction="row" alignItems={'center'} spacing={1} color="primary" aria-label="outlined primary button group">

                    {
                        options.map((event) => (
                            <Grid item key={event.id} sm={2}>
                                <Pill
                                    textField={'name'}
                                    item={event}
                                    outlined={!transformedInSelectedOptions.some((option) => option.id === event.id)}
                                    onClick={(event) => {
                                        const eventsResult = [...transformedInSelectedOptions];
                                        const checkedEvent = transformedInSelectedOptions.find((option) => option.id === event.id);
                                        if (checkedEvent) {
                                            eventsResult.splice(eventsResult.indexOf(checkedEvent), 1);
                                        } else {
                                            eventsResult.push(event);
                                        }
                                        onChange({ ...value, offHourEvents: transformedOutSelectedOptions(eventsResult) });
                                    }}
                                    style={{ border: '0', margin: '2px 0', width: '100%' }}
                                    label="pill-label-text"
                                    colorField="default"
                                />
                            </Grid>
                        ))
                    }
                </Grid>
                <Grid item style={{paddingTop:10}}>
                    <TriggerLandmark config={value} triggers={triggers} triggersRaw={triggersRaw} onChange={onChange} showErrorTrigger={showErrorTrigger}/>
                </Grid>
            </Grid>
        </Form>
    );
}
